import styled from "styled-components";

const Back = styled.button`
  position: relative;
  font-size: 14px;
  background: none;
  font-weight: bold;
  border: none;
  color: white;
  text-transform: uppercase;
  padding: 0;
  margin-bottom: 10px;
  cursor: pointer;

  &:before {
    content: "‹";
    position: absolute;
    left: -10px;
    font-size: 20px;
    font-weight: normal;
    top: 3px;
    line-height: 13px;
  }

  &:hover {
    text-decoration: underline;
  }
`;

export default Back;
